import React from 'react'
import { Image, type ViewStyle } from "react-native"
import type { LeagueProps } from '../types'
import { Button, Text } from './Themed'
import { useColors } from '../constants/useColors'


type LeagueLozengeProps = {
    league: LeagueProps,
    is_active?:boolean,
    text_size?:number,
    style?:ViewStyle,
    onSelect: (league:LeagueProps) => void
}
export const LeagueLozenge = ({ league, style, is_active, text_size, onSelect }:LeagueLozengeProps) => {
    const Colors = useColors();
    const handleSelect = () => {
        if(!onSelect){ return }
        onSelect(league)
    }
    
    return (
        <Button float style={{ flexDirection:'row', alignItems:'center', margin:4, borderWidth:1, borderColor:is_active?Colors.text.success: Colors.borders.light, borderRadius:100, padding:10, paddingRight:text_size??20, paddingLeft:text_size??20, ...style }} onPress={() => handleSelect()}>
            {league.league_image ?
            <Image
                source={{ uri: league.league_image }}
                style={{ height:18, width:18, marginRight:5 }}
                resizeMode='cover'
            />
            :<></>}
            <Text size={text_size??16} color={is_active ? Colors.text.success : undefined} theme='h2'>{league.league_name}</Text>
        </Button>
    )
}

export default LeagueLozenge